/**
 * Copyright (c) 2018
 * @summary Publishing the protocol setup modal popup
 * @author Ankur Vishwakarma,Poonam Banode,Mangesh Pimprikar,Irfan Bagwan
 */

import React from 'react';

import ModalBoxes from '../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../common/general/ButtonGroup';
import NotificationManager from '../../../../../../common/notifications/NotificationManager';
import { FILL_REQUIRED } from '../../../../../../constants/notificationMessages';

import 'react-datetime/css/react-datetime.css';

class DndPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: ''
    };
  }

  onClose = () => {
    this.props.modalBox.close();
    if (this.props.afterClose) {
      this.props.afterClose();
    }
  };

  onChangeText = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  onSaveReason = () => {
    if (this.state.comment?.trim()) {
      this.props.onSave && this.props.onSave(this.state);
    } else {
      NotificationManager.error(FILL_REQUIRED);
    }
  };

  render() {
    return (
      <>
        <ModalBoxes.Body>
          <div className="row col-sm-12">
            <label className="text-left col-sm-2 pr-0 pl-0">Comment</label>
            <textarea
              row="4"
              name="comment"
              onChange={this.onChangeText}
              className="form-control input-group col-sm-10 reqfeild"
            />
          </div>
        </ModalBoxes.Body>
        <ModalBoxes.Footer>
          <ButtonGroup>
            <Button priority="medium" onClick={this.onClose}>
              Cancel
            </Button>
            <Button onClick={this.onSaveReason}>Save</Button>
          </ButtonGroup>
        </ModalBoxes.Footer>
      </>
    );
  }
}

DndPopup.className = 'dnd-popup-modal';
DndPopup.size = 'w650';

export default DndPopup;
